import { FormattedMessage } from 'react-intl';
import { HistoryItem } from '@stellab/cs-schemas';

import Hr from '@components/ui/Hr';
import FileHistoryItem from './FileHistoryItem';

type Props = {
  history: HistoryItem[];
};

const FileHistory = ({ history }: Props) => {
  return (
    <div className="shadow-md rounded-lg bg-white p-8 border-2 border-gray-50 w-full mt-16">
      <h5 className="text-center">
        <FormattedMessage id="view.history.header" defaultMessage="History" description="Subheader in view page" />
      </h5>

      <Hr className="mb-4" />

      {history.map(item => (
        <FileHistoryItem item={item} key={item.createdAt.unix} />
      ))}
    </div>
  );
};

export default FileHistory;
